export const flexMapperWithIndex: any = {
  0: 0.5,
  1: 1,
  2: 1,
  3: 1,
  4: 1,
}

export const headerData = [
  {
    title: 'File Id',
  },
  {
    title: 'File Name',
  },
  {
    title: 'Processed Date/Time',
  },
  {
    title: 'Status',
  },
  // {
  //   title: 'Failure Reason',
  // },
  {
    title: 'Actions',
  },
]
